module.exports = __webpack_public_path__ + "images/sprites/ui/arrow_dot_bottom_f823d19abc9067a75e23cc32e317a7e5.png";